import ScheduleSelect from './components/ScheduleSelect';
import React from 'react';
import { graphql, compose } from 'react-apollo';
import { connect } from 'react-redux';
import gql from 'graphql-tag';

import LoginHOC from '../../../../components/LoginHOC';
import Spinner from '../../../../components/Spinner/';

const createAdvisorNodes = gql`
mutation($Nodes: [ScheduleNodeInput]) {
  createAdvisorScheduleNodes(Nodes: $Nodes) {
    id
    start_timestamp
    end_timestamp
  }
}
`;

const updateAdvisorNodes = gql`
mutation($Nodes: [ScheduleNodeUpdate]) {
  updateAdvisorScheduleNodes(Nodes: $Nodes) {
    id
    start_timestamp
    end_timestamp
  }
}
`;

const deleteAdvisorNodes = gql`
mutation($Nodes: [Int]) {
  deleteAdvisorScheduleNodes(Nodes: $Nodes) {
    status
  }
}
`;

const readAdvisorNodes = gql`
query ($UserID: Int!) {
  getAdvisorScheduleNodes(userID: $UserID) {
    id
    start_timestamp
    end_timestamp
    negative_positive
    module_instance {
      id
      student {
        first_name
        last_name
      }
      module {
        module_name
      }
    }
  }
}
`;

const AdvisorSessions = gql`
query {
  listSessions {
    id
    module_instance_status {
      id
    }
    module {
      module_name
      duration_minutes
      description
    }
    student {
      first_name
      last_name
    }
    Industry {
      name
    }
  }
}
`;

const acceptSession = gql`
mutation($ModuleInstance: Int!) {
  acceptSession(ModuleInstanceID: $ModuleInstance) {
    status
  }
}
`;

const mapStateToProps = (state) => ({
  authedUserID: state.auth.sub || null,
  authedUser: state.auth || null,
});

export default (store) => ({
  component: LoginHOC(connect(mapStateToProps)(compose(
    graphql(createAdvisorNodes, {
      name: 'createAdvisorNodes',
    }),
    graphql(updateAdvisorNodes, {
      name: 'updateAdvisorNodes',
    }),
    graphql(deleteAdvisorNodes, {
      name: 'deleteAdvisorNodes',
    }),
    graphql(AdvisorSessions, {
      name: 'AdvisorSessions',
    }),
    graphql(acceptSession, {
      name: 'AcceptSession',
    }),
    graphql(readAdvisorNodes, {
      nane: 'AdvisorNodeData',
      options: OwnProps => {
        return ({
          variables: {
            UserID: OwnProps.authedUserID || store.getState().auth.sub,
          },
          fetchPolicy: 'network-only'
        });
      },
    })
  )(props => { // Wait for schedule data
    if (props.data.loading === false) {
      return <ScheduleSelect {...props} />;
    }
    return <Spinner />;
  }))),
});



// WEBPACK FOOTER //
// ./src/routes/scheduler/routes/ViewScheduler/index.js